import { createFileRoute } from '@tanstack/react-router';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from '../messages';
import { WithdrawFundsSelectComponent } from './components/WithdrawFundsSelect/WithdrawFundsSelect';
import { z } from 'zod';
import { zodValidator } from '@tanstack/zod-adapter';

const searchParamsSchema = z.object({
  pendingModal: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/funds/withdraw/')({
  component: WithdrawFundsSelect,
  validateSearch: zodValidator(searchParamsSchema),
});

function WithdrawFundsSelect() {
  const { pendingModal } = Route.useSearch();

  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page="/funds/withdraw"
      />
      <div className="px-6 py-4">
        <WithdrawFundsSelectComponent pendingProductModal={pendingModal} />
      </div>
    </>
  );
}
